import {ExpenseAttachment} from '../expenseAttachment';

export function toString(this: ExpenseAttachment) {
    return `Deal: ${this.id}`;
}
